/**
 * “科创中国”美团青山环保科技创新示范项目简介
 */
import React from 'react';
import './index.scss';
import Rule from './rule';
import { KechuangHeader } from '../../../components/KechuangHeader/KechuangHeader';

const regulation = () => {
  return (
    <div className="environment-regulation">
      <KechuangHeader />
      <div className="award-charter marker">
        <div id={'manage'} style={{ position: 'relative', top: -150 }} />
        <span className="title">“科创中国”美团青山环保科技创新示范项目章程</span>
        <Rule />
      </div>
    </div>
  );
};

export default regulation;
